import type { Person } from '../domain/Person';

/** "First Last", or "(unknown name)" when both are blank. GEDCOM text — render via textContent. */
export function personDisplayName(person: Person): string {
  return `${person.name.first} ${person.name.last}`.trim() || '(unknown name)';
}
